var _path;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
const SvgThumbsUp = props => /*#__PURE__*/React.createElement("svg", _extends({
  viewBox: "0 0 24 24",
  xmlns: "http://www.w3.org/2000/svg"
}, props), _path || (_path = /*#__PURE__*/React.createElement("path", {
  d: "M3 9h1.75A1.25 1.25 0 0 1 6 10.25v9.5A1.25 1.25 0 0 1 4.75 21H3V9Zm10.5 0h3.91a3 3 0 0 1 2.95 3.54l-.91 5A3 3 0 0 1 16.5 20H7v-9l2.93-4.88a.48.48 0 0 0 .07-.26V3h.5A2.5 2.5 0 0 1 13 5.5v3a.5.5 0 0 0 .5.5Z"
})));
export default SvgThumbsUp;